import { Global, css } from "@emotion/react"
import { Fragment } from "react"

import {
  Container,
  Heading,
  Icon,
  IconButton,
  UserGeneratedHtml,
} from "@trueskin-web/components"
import { checkIcon } from "@trueskin-web/theme/icons/checkIcon"
import { closeIcon } from "@trueskin-web/theme/icons/closeIcon"

import ProductCallout from "../../../components/choose-plan/components/product-callout"
import ProductGallery from "../../../components/choose-plan/components/product-gallery"

const ProductDetailsDialog = ({
  isOpen,
  onDismiss,
  title,
  primaryColor,
  secondaryColor,
  slides = [],
  callout,
  sections = [],
  ingredients = [],
}) => {
  return (
    <Fragment>
      {isOpen && (
        <Global
          styles={css`
            body {
              // mobile ios hack 🙄
              position: fixed;
              width: 100%;
              overflow-y: hidden;
            }
          `}
        />
      )}

      <div
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          zIndex: isOpen ? 10 : -1,
          opacity: isOpen ? 1 : 0,
          background: "rgba(0, 0, 0, 0.30)",
          display: "flex",
          justifyContent: [null, "center"],
          alignItems: [null, "center"],
        }}
        data-testid="web-portal-plan-selection-products-dialog"
      >
        <div
          sx={{
            height: [null, "90vh"],
            width: [null, "50vw"],
            maxWidth: [null, "700px"],
            zIndex: 10,
            bg: "background",
            lineHeight: "body",
            position: "relative",
            overflowY: "auto",
            transform: isOpen ? "translateY(0)" : "translateY(100%)",
            transitionProperty: "transform",
            transitionDuration: "0.4s",
            transitionTimingFunction: "cubic-bezier(0, 0.4, 0.2, 1)",
          }}
        >
          <IconButton
            icon={closeIcon}
            onClick={onDismiss}
            sx={{
              position: "absolute",
              top: 4,
              right: 4,
              width: 32,
              height: 32,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bg: "background",
              borderRadius: "50%",
              zIndex: 10,
            }}
          />

          {slides.length > 0 && <ProductGallery slides={slides} />}

          <Container sx={{ mt: "40px", mb: 9 }}>
            <Heading
              as="h3"
              mb={2}
              sx={{
                fontFamily: "NeueHaasGroteskDisplay Pro",
                lineHeight: "smallerHeading",
              }}
            >
              {title}
            </Heading>

            <ProductCallout
              primaryColor={primaryColor}
              secondaryColor={secondaryColor}
              {...callout}
            />

            {sections.length > 0 &&
              sections.map(({ title, description }, index) => (
                <div key={index}>
                  <Heading
                    as="h4"
                    size="sm"
                    mt={5}
                    mb={4}
                    sx={{
                      fontFamily: "NeueHaasGroteskDisplay Pro",
                      lineHeight: "smallerHeading",
                    }}
                  >
                    {title}
                  </Heading>
                  <UserGeneratedHtml
                    html={description}
                    sx={{ color: "textDark" }}
                  />
                </div>
              ))}

            {ingredients.length > 0 &&
              ingredients.map(({ title, image: Image, lines }, index) => (
                <div
                  key={index}
                  sx={{
                    mt: 5,
                    display: "grid",
                    gridTemplateColumns: "auto 1fr",
                    gap: 4,
                  }}
                >
                  {Image && (
                    <Image
                      alt=""
                      sx={{
                        width: 80,
                        height: 80,
                      }}
                    />
                  )}
                  <div>
                    {title}
                    {lines.map((line, index) => (
                      <div
                        key={index}
                        sx={{
                          fontSize: 1,
                          display: "grid",
                          gridTemplateColumns: "auto 1fr",
                        }}
                      >
                        <Icon
                          icon={checkIcon}
                          color="brandPrimary"
                          sx={{ mr: 1 }}
                        />
                        {line}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
          </Container>
        </div>
      </div>
    </Fragment>
  )
}

export default ProductDetailsDialog
